"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var PlannerSorting_1 = require("../../types/enums/PlannerSorting");
var constants_1 = require("./constants");
var reducers = {
    recordings: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_ALL_RECORDINGS] = function (_, action) { return action.payload; },
        _a[constants_1.REMOVE_RECORDING] = function (state, action) {
            var removeIds = action.payload;
            return state.filter(function (_a) {
                var id = _a.id;
                return !removeIds.includes(id);
            });
        },
        _a), []),
    recordingSettings: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_RECORDING_SETTINGS] = function (_, action) {
            return action.payload;
        },
        _b), {}),
    plannerSorting: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_PLANNER_SORTING] = function (_, action) { return action.payload; },
        _c), PlannerSorting_1.PlannerSorting.NEWEST),
    scheduledRecordings: api_1.createCustomModuleReducer(__assign((_d = {}, _d[constants_1.SET_SCHEDULED_RECORDING_SET] = function (draftState, action) {
        var _a;
        if (action.payload.version > ((_a = draftState.data) === null || _a === void 0 ? void 0 : _a.version)) {
            draftState.data = action.payload;
        }
    }, _d), api_1.createApiReducer({
        actionType: constants_1.FETCH_SCHEDULED_RECORDINGS,
        onSuccess: function (draftState, action) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (((_d = (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.decoder) === null || _c === void 0 ? void 0 : _c.queuedRecordings) === null || _d === void 0 ? void 0 : _d.version) >= ((_e = draftState.data) === null || _e === void 0 ? void 0 : _e.version)) {
                draftState.data = (_h = (_g = (_f = action.payload) === null || _f === void 0 ? void 0 : _f.customer) === null || _g === void 0 ? void 0 : _g.decoder) === null || _h === void 0 ? void 0 : _h.queuedRecordings;
            }
        },
    })), api_1.createApiInitialState({
        version: 0,
        slots: [],
        recordRequests: [],
    })),
    recordProgramme: api_1.createCustomModuleReducer(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.RECORD_PROGRAMME,
        onSuccess: function (draftState, action) {
            var _a, _b;
            // only set error into state.
            if (((_a = action.payload.recordProgram) === null || _a === void 0 ? void 0 : _a.__typename) !== 'QueuedRecordingSet') {
                draftState.data = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.recordProgram;
            }
            else {
                // Avoid the whole QueuedRecordingSet saved duplicatedly in the sub module
                draftState.data = null;
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.CANCEL_RECORD_PROGRAMME,
        // Avoid the whole QueuedRecordingSet saved duplicatedly in the sub module
        onSuccess: function () { },
    })), (_e = {}, _e[constants_1.RESET_RECORD_PROGRAMME] = function () { return api_1.createApiInitialState(null); }, _e)), api_1.createApiInitialState(null)),
    recordSeriesLink: api_1.createCustomModuleReducer(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.RECORD_SERIES_LINK,
        onSuccess: function (draftState, action) {
            var _a, _b;
            // only set error into state.
            if (((_a = action.payload.recordSeriesLink) === null || _a === void 0 ? void 0 : _a.__typename) !== 'QueuedRecordingSet') {
                draftState.data = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.recordSeriesLink;
            }
            else {
                // Avoid the whole QueuedRecordingSet saved duplicatedly in the sub module
                draftState.data = null;
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.CANCEL_RECORD_SERIES_LINK,
        // Avoid the whole QueuedRecordingSet saved duplicatedly in the sub module
        onSuccess: function () { },
    })), (_f = {}, _f[constants_1.RESET_RECORD_SERIES_LINK] = function () { return api_1.createApiInitialState(null); }, _f)), api_1.createApiInitialState(null)),
    migrateRecordings: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.MIGRATE_RECORDINGS,
        onSuccess: function (draftState) {
            draftState.data = { isCompleted: true };
        },
    })), (_g = {}, _g[constants_1.SET_MIGRATION_COMPLETED] = function (draftState) {
        draftState.data = { isCompleted: true };
    }, _g)), api_1.createApiInitialState({ isCompleted: false })),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map